import React from 'react';

const CodeCellRenderer = (params) => {
    const {value, data, openConnection} = params;
    const {can_use_ssh, id} = data;

    return (
        <>
            <div className={can_use_ssh ? "text-blue-700 w-full hover:underline" : ""} onClick={() => openConnection(data, id)}>
                {value}
            </div>
        </>
    );
};

export default CodeCellRenderer;